import { useMemo } from 'react';
import { useLifeAreasQuery } from 'shared/hooks/queries/use-life-areas-query';
import { useUser } from 'shared/hooks/use-user';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { LifeArea } from 'shared/types/life-area';
import { getLocalizedStringValue } from 'shared/utils/get-localized-string-value';

export type Options = {
  enabled?: boolean;
  activeOnly?: boolean;
};

export const useLocalizedLifeAreas = ({
  enabled = true,
  activeOnly,
}: Options = {}) => {
  const locale = useI18nLocale();
  const user = useUser();

  const { data } = useLifeAreasQuery(user?.uid, {}, enabled);

  return useMemo(
    () =>
      data?.reduce<LifeArea[]>((acc, { name, ...lifeArea }) => {
        if (!activeOnly || (!lifeArea.archivedAt && !lifeArea.frozenAt)) {
          acc.push({
            ...lifeArea,
            name: getLocalizedStringValue(name, locale),
          });
        }
        return acc;
      }, []) ?? [],
    [activeOnly, data, locale],
  );
};
